import { Values } from 'ha/constants/Facilities';
import { TranslateFunc } from 'ha/i18n';

interface Room {
  facility_water_cost_included: string;
  facility_gas_cost_included: string;
  facility_electricity_included: string;
  facility_internet_included: string;
}

export function getBillsLabel(room: Room, T: TranslateFunc) {
  const bills = [
    room.facility_water_cost_included,
    room.facility_gas_cost_included,
    room.facility_electricity_included,
    room.facility_internet_included,
  ];

  if (bills.every(included => included === Values.Yes)) {
    return T('Bills Included');
  }

  if (bills.some(included => included === Values.Yes)) {
    return T('Some bills included');
  }

  return T('Bills Excluded');
}
